export default {
  route: {
    sysOrg: 'Org Manage', // 机构管理
    sysDic: 'div Manage', // 字典管理
    sys: 'Sys	Manage', // 系统管理
    role: 'Role Manage', // 角色管理
    perm: 'Perm Manage', // 权限管理
    user: 'User Manage', // 员工管理
    sysLog: 'system log', // 系统日志
    logTranslate: 'log Translate' // 日志字典
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    screenfull: 'screenfull',
    theme: 'theme'
  },
  login: {
    title: 'Intelligent management platform for Harbin bulk cement industry',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  table: {
    add: 'add',
    id: 'id',
    actions: 'actions',
    search: 'search',
    export: 'export'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js